import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { useMemo as a } from "react";
import d from "./index.es5641.js";
import { Icon as h } from "./index.es147.js";
import { BodyText as l } from "./index.es487.js";
const A = ({
  label: n,
  parenthesisValue: e,
  testId: i = "parenthesis-cell",
  type: o = "positive",
  addArrowIndication: p
}) => {
  const s = a(
    () => o === "positive" ? "success" : o === "negative" ? "error" : "primary",
    [o]
  ), c = o !== "neutral" && p, t = o === "positive";
  return /* @__PURE__ */ m("div", { className: d.parenthesisCellRoot, children: [
    /* @__PURE__ */ r(l, { color: "primary", element: "p", isEllipsis: !0, "data-testid": i, children: n }),
    e && /* @__PURE__ */ r(
      l,
      {
        color: s,
        element: "p",
        isEllipsis: !0,
        "data-testid": i + "-parenthesis-value",
        children: ` (${e})`
      }
    ),
    c && /* @__PURE__ */ r(
      h,
      {
        type: t ? "ArrowUp" : "ArrowDown",
        size: 16,
        color: s,
        weight: "outline",
        testId: `icon-${t ? "ArrowUp" : "ArrowDown"}`
      }
    )
  ] });
};
export {
  A as ParenthesisCell
};
//# sourceMappingURL=index.es632.js.map
